import RewardsV2 from './RewardsV2';

export default RewardsV2;
